import { HiShieldCheck } from "react-icons/hi2";

/** Matches new-ui `MarketplaceHome` strip directly under `HeroSlider` (bg + border-y + copy). */
export default function HomeGuaranteeStrip() {
  return (
    <section className="bg-[#0a0a0a]">
      <div className="border-y border-white/[0.06] py-4">
        <div className="flex items-center justify-center gap-3">
          <div className="hidden sm:block w-16 h-px bg-gradient-to-r from-transparent to-white/10" />
          <div className="flex items-center gap-2.5">
            <HiShieldCheck className="w-4 h-4 text-[#00C853] shrink-0" strokeWidth={1.8} aria-hidden />
            <span
              className="text-[12px] text-white/50 tracking-wide"
              style={{ fontFamily: "'Outfit', 'Inter', sans-serif", fontWeight: 500 }}
            >
              Every Ticket{" "}
              <span className="text-white/80" style={{ fontWeight: 700 }}>
                100% Guaranteed
              </span>
            </span>
          </div>
          <div className="hidden sm:block w-16 h-px bg-gradient-to-l from-transparent to-white/10" />
        </div>
      </div>
    </section>
  );
}
